import { render, staticRenderFns } from "./CTA02.vue?vue&type=template&id=1ab5ec04"
import script from "./CTA02.vue?vue&type=script&lang=js"
export * from "./CTA02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports